const Endpoints = {
  // feed_types: '/feedback/crud/feedback_type/',
  // event_type: '/feedback/crud/event_type/',
  feed: '/feedback/',
  enquiry: '/enquiry/',
  constants: '/constants/',
};

export default Endpoints;
